import script from "./_filter-value-bubble.vue?vue&type=script&setup=true&lang=js"
export * from "./_filter-value-bubble.vue?vue&type=script&setup=true&lang=js"

import "./_filter-value-bubble.vue?vue&type=style&index=0&id=70c1dd4b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c1dd4b"]])

export default __exports__